module.exports = __webpack_public_path__ + "static/media/mobiles.f879474b.webp";


//////////////////
// WEBPACK FOOTER
// ./src/views/products/artist/assets/mobiles.webp
// module id = 289
// module chunks = 0